<template><section class="r7-section"><div class="r7-container"><h2>{{ $t('skills.boundaryTitle') }}</h2><p>{{ $t('skills.boundaryIntro') }}</p></div></section></template>

<script>
export default {
  name: 'BadgeAndRankSystem'
}
</script>

<style scoped>
.badge-rank {
  padding: 5rem 2rem;
  background: #020617;
  border-top: 1px solid rgba(148, 163, 184, 0.12);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 0.5rem;
  background: linear-gradient(135deg, #00D9FF, #0066FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-subtitle {
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.1rem;
  margin-bottom: 3rem;
}

.rank-system {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.rank-tier {
  padding: 2rem;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.6), rgba(10, 36, 99, 0.4));
  border: 2px solid rgba(0, 217, 255, 0.2);
  border-radius: 12px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.rank-tier::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #00D9FF, #0066FF, #8A2BE2);
}

.rank-tier:hover {
  border-color: rgba(0, 217, 255, 0.4);
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 217, 255, 0.2);
}

.rank-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.rank-name {
  font-size: 1.3rem;
  font-weight: 700;
  color: #FFFFFF;
}

.rank-level {
  font-size: 0.9rem;
  color: #00D9FF;
  font-weight: 600;
}

.rank-tier p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.badge {
  display: inline-block;
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, rgba(0, 217, 255, 0.2), rgba(0, 102, 255, 0.15));
  border: 1px solid rgba(0, 217, 255, 0.3);
  border-radius: 20px;
  color: #00D9FF;
  font-size: 0.85rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.badge:hover {
  background: linear-gradient(135deg, rgba(0, 217, 255, 0.3), rgba(0, 102, 255, 0.25));
  border-color: rgba(0, 217, 255, 0.5);
  box-shadow: 0 0 10px rgba(0, 217, 255, 0.2);
}

@media (max-width: 768px) {
  .section-title {
    font-size: 1.8rem;
  }

  .badge-rank {
    padding: 3rem 1.5rem;
  }
}
</style>
